<template>
  <div id="app">
    <link rel="stylesheet" type="text/css" href="/styles/bootstrap4/bootstrap.min.css" />
    <link
      href="/plugins/font-awesome-4.7.0/css/font-awesome.min.css"
      rel="stylesheet"
      type="text/css"
    />
    <link rel="stylesheet" type="text/css" href="/plugins/OwlCarousel2-2.2.1/owl.carousel.css" />
    <link
      rel="stylesheet"
      type="text/css"
      href="/plugins/OwlCarousel2-2.2.1/owl.theme.default.css"
    />
    <link rel="stylesheet" type="text/css" href="/plugins/OwlCarousel2-2.2.1/animate.css" />
    <link href="/plugins/magnific-popup/magnific-popup.css" rel="stylesheet" type="text/css" />
    <link rel="stylesheet" type="text/css" href="/styles/main_styles.css" />
    <link rel="stylesheet" type="text/css" href="/styles/responsive.css" />

    <LoggedUser v-if="loggedUser" class="loggedUser" />
    <Menu />
    <router-view v-if="initFetched" />
    <Subscribe />
    <Footer />
    <notifications :position="'bottom left'" />

    <script2 src="/js/jquery-3.2.1.min.js"></script2>
    <script2 src="/styles/bootstrap4/popper.js"></script2>
    <script2 src="/styles/bootstrap4/bootstrap.min.js"></script2>
    <script2 src="/plugins/OwlCarousel2-2.2.1/owl.carousel.js"></script2>
    <script2 src="/plugins/easing/easing.js"></script2>
    <script2 src="/plugins/magnific-popup/jquery.magnific-popup.min.js"></script2>
    <script2 src="/js/custom.js"></script2>
    <link
      href="https://fonts.googleapis.com/css?family=Source+Sans+Pro&display=swap"
      rel="stylesheet"
    />
  </div>
</template>

<script>
import storage from 'store'
import Menu from '@/components/Menu.vue'
import Subscribe from '@/components/Subscribe.vue'
import Footer from '@/components/Footer.vue'
import LoggedUser from '@/components/LoggedUser.vue'
import cli from '@/http.js'
import '@/assets/marena.css'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'App',
  components: {
    Menu,
    Subscribe,
    Footer,
    LoggedUser,
  },
  computed: {
    ...mapState(['loggedUser']),
  },
  data() {
    return {
      initFetched: false,
    }
  },
  async created() {
    const lastUser = storage.get('user')
    if (lastUser) {
      const token = lastUser.token
      cli.defaults.headers.common.Authorization = `Token ${token}`
      try {
        const resp = await cli.get('/users/me/')
        await this.setUser(resp.data)
      } catch (err) {
        storage.remove('user')
      }
    }
    this.initFetched = true
  },
  methods: {
    ...mapMutations(['setUser']),
  },
}
</script>

<style scoped>
.loggedUser {
  position: absolute;
  color: black;
  background: rgba(255, 255, 255, 0.5);
  z-index: 100;
  right: 4px;
}
</style>
